module.exports = __webpack_public_path__ + "static/media/carta_16.ee17390e.jpg";